import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const getFormType = (type: string): string => {
  return "FORMS.TYPE." + type;
}

export const forbiddenNameValidator = (names: string[]): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden = names.find(item => item.toUpperCase() === control.value.toUpperCase());
    return forbidden ? {forbiddenName: {value: control.value}} : null;
  };
};